import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationUser } from "../../all_Interfaces";
import { getApiCall } from "../../services/apiHelper";
import { InvestmentServiceURL } from "../../config/config";
import { ServiceName } from "../../constants";


interface InitialState {
    data: ApplicationUser[],
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as ApplicationUser[],
    error: '',
    loading: false
}

export const getAllApplicationUser = createAsyncThunk("getAllApplicationUser", async () => {
    try{
        const response = await getApiCall<any>(InvestmentServiceURL+"/investments/getalluser",ServiceName.INVESTMENTSERVICE);
        return response.result;
    }catch (error:any) {
        console.error("Error in POST request:", error);
        return error.message;
      }
} );
const allApplicationUserSlice = createSlice({
    name: "applicationUsers",
    initialState,
    reducers: {},
    extraReducers:(builder) => {
        builder.addCase(getAllApplicationUser.pending,(state) => {
            state.loading = true;
        }).addCase(getAllApplicationUser.fulfilled, (state, action: PayloadAction<ApplicationUser[]>) => {
            state.data = action.payload;
            state.loading = false;
            state.error = '';
        }).addCase(getAllApplicationUser.rejected,(state,action)=>{
            state.loading = false;
            state.error = action.error.message || "Something went wrong";
        })
    },
});

export const { } = allApplicationUserSlice.actions;

export default allApplicationUserSlice.reducer;